<script lang="ts" setup>
const header = ref<HTMLElement | null>(null)
const headerHeight = ref('auto')

useResizeObserver(header, (entries) => {
  const entry = entries[0]

  if (entry?.contentRect) {
    const { height } = entry.contentRect
    headerHeight.value = `${height}px`
  }
})
</script>

<template>
  <header
    ref="header"
    class="checkout-header"
  >
    <Html
      v-if="headerHeight !== 'auto'"
      :style="`--header-height: ${headerHeight};`"
    />

    <div class="checkout-header__container">
      <CheckoutSteps class="checkout-header__steps" />

      <AppLogo
        data-testid="logo"
        class="checkout-header__logo"
      />

      <HeaderCart class="checkout-header__mini-cart" />
    </div>
  </header>
</template>

<style>
@import url("~layers/components/Checkout/Header.css");
</style>
